import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-down-arrow',
  templateUrl: './down-arrow.component.html',
  styleUrls: ['./down-arrow.component.scss'],
})
export class DownArrowComponent implements OnInit {
  @Input() style: CSSStyleRule;
  @Input() customClass: string = '';
  constructor() {}

  ngOnInit(): void {}
}
